export default {"src":"/_next/static/media/checklist.54de6435.svg","height":32,"width":32};